/* eslint-disable max-lines */

import type { Route } from '@angular/router';

import { provideTemplateDefinition } from './app/providers/template-definition.provider';
import {
  AccountRecoveryRequestStartedTemplateComponent,
  AccountRecoveryRequestStartedTemplateMocks,
} from './app/templates/account-recovery-request-started/account-recovery-request-started.component';
import {
  AccountRecoveryRequestUrlTemplateComponent,
  AccountRecoveryRequestUrlTemplateMocks,
} from './app/templates/account-recovery-request-url/account-recovery-request-url.component';
import {
  AdminDeletedTemplateComponent,
  AdminDeletedTemplateMocks,
} from './app/templates/admin-deleted/admin-deleted.component';
import {
  AdminDeletionRequestCreatedTemplateComponent,
  AdminDeletionRequestCreatedTemplateMocks,
} from './app/templates/admin-deletion-request-created/admin-deletion-request-created.component';
import {
  AdminDeletionScheduledTemplateComponent,
  AdminDeletionScheduledTemplateMocks,
} from './app/templates/admin-deletion-scheduled/admin-deletion-scheduled.component';
import {
  AfterSubscriptionDowngradeTemplateComponent,
  AfterSubscriptionDowngradeTemplateMocks,
} from './app/templates/after-subscription-downgrade/after-subscription-downgrade.component';
import {
  BeforeSubscriptionDowngradeTemplateComponent,
  BeforeSubscriptionDowngradeTemplateMocks,
} from './app/templates/before-subscription-downgrade/before-subscription-downgrade.component';
import {
  BrokenSyncAlertTemplateComponent,
  BrokenSyncAlertTemplateMocks,
} from './app/templates/broken-sync-alert/broken-sync-alert.component';
import {
  CampaignContractSubmittedTemplateTemplateComponent,
  CampaignContractSubmittedTemplateTemplateMocks,
} from './app/templates/campaign-contract-submitted-template/campaign-contract-submitted-template.component';
import {
  CampaignProductStatusChangedTemplateComponent,
  CampaignProductStatusChangedTemplateMocks,
} from './app/templates/campaign-product-status-changed/campaign-product-status-changed.component';
import {
  CampaignSubmittedTemplateComponent,
  CampaignSubmittedTemplateMocks,
} from './app/templates/campaign-submitted/campaign-submitted.component';
import {
  CandidateSharedTemplateComponent,
  CandidateSharedTemplateMocks,
} from './app/templates/candidate-shared/candidate-shared.component';
import {
  CompanyDeletedTemplateComponent,
  CompanyDeletedTemplateMocks,
} from './app/templates/company-deleted/company-deleted.component';
import {
  CompanyDeletionRequestCreatedTemplateComponent,
  CompanyDeletionRequestCreatedTemplateMocks,
} from './app/templates/company-deletion-request-created/company-deletion-request-created.component';
import { CompanyDeletionScheduledTemplateMocks } from './app/templates/company-deletion-scheduled/company-deletion-scheduled.component';
import {
  CompanyVerificationRequestTemplateComponent,
  CompanyVerificationRequestTemplateMocks,
} from './app/templates/company-verification-request/company-verification-request.component';
import {
  CompleteAccountSetupTemplateComponent,
  CompleteAccountSetupTemplateMocks,
} from './app/templates/complete-account-setup/complete-account-setup.component';
import { DemoTemplateComponent, DemoTemplateMocks } from './app/templates/demo/demo.component';
import {
  EeoDataRequestTemplateComponent,
  EeoDataRequestTemplateMocks,
} from './app/templates/eeo-data-request/eeo-data-request.component';
import {
  EmailChangeStartProcessTemplateComponent,
  EmailChangeStartProcessTemplateMocks,
} from './app/templates/email-change-start-process/email-change-start-process.component';
import {
  EmailChangeVerificationTemplateComponent,
  EmailChangeVerificationTemplateMocks,
} from './app/templates/email-change-verification/email-change-verification.component';
import {
  EmailNotDeliveredTemplateComponent,
  EmailNotDeliveredTemplateMocks,
} from './app/templates/email-not-delivered/email-not-delivered.component';
import {
  EventNotificationTemplateComponent,
  EventNotificationTemplateMocks,
} from './app/templates/event-notification/event-notification.component';
import {
  EventReminderScheduledTemplateComponent,
  EventReminderScheduledTemplateMocks,
} from './app/templates/event-reminder-scheduled/event-reminder-scheduled.component';
import {
  FeatureRequestCreatedTemplateComponent,
  FeatureRequestCreatedTemplateMocks,
} from './app/templates/feature_request_created/feature_request_created.component';
import {
  GdprAutoConsentTemplateComponent,
  GdprAutoConsentTemplateMocks,
} from './app/templates/gdpr-auto-consent/gdpr-auto-consent.component';
import {
  GdprReportTemplateComponent,
  GdprReportTemplateMocks,
} from './app/templates/gdpr-report/gdpr-report.component';
import {
  InactiveAdminDeletedTemplateComponent,
  InactiveAdminDeletedTemplateMocks,
} from './app/templates/inactive-admin-deleted/inactive-admin-deleted.component';
import { InactiveCompanyDeletedTemplateMocks } from './app/templates/inactive-company-deleted/inactive-company-deleted.component';
import {
  JoinCompanyTemplateComponent,
  JoinCompanyTemplateMocks,
} from './app/templates/join-company/join-company.component';
import {
  MultipleNotificationsTemplateComponent,
  MultipleNotificationsTemplateMocks,
} from './app/templates/multiple-notifications/multiple-notifications.component';
import {
  NewCandidateTemplateComponent,
  NewCandidateTemplateMocks,
} from './app/templates/new-candidate/new-candidate.component';
import {
  NewCandidatesReportTemplateComponent,
  NewCandidatesReportTemplateMocks,
} from './app/templates/new-candidates-report/new-candidates-report.component';
import {
  NotificationMentionTemplateComponent,
  NotificationMentionTemplateMocks,
} from './app/templates/notification-mention/notification-mention.component';
import {
  ReferralApplicationConfirmationTemplateComponent,
  ReferralApplicationConfirmationTemplateMocks,
} from './app/templates/referral-application-confirmation/referral-application-confirmation.component';
import {
  ReferralEmailConfirmationTemplateComponent,
  ReferralEmailConfirmationTemplateMocks,
} from './app/templates/referral-email-confirmation/referral-email-confirmation.component';
import {
  ReferralSendInvitationTemplateComponent,
  ReferralSendInvitationTemplateMocks,
} from './app/templates/referral-send-invitation/referral-send-invitation.component';
import {
  RequisitionsApprovalRequestTemplateComponent,
  RequisitionsApprovalRequestTemplateMocks,
} from './app/templates/requisitions-approval-request/requisitions-approval-request.component';
import {
  RescheduledEventNotificationTemplateComponent,
  RescheduledEventNotificationTemplateMocks,
} from './app/templates/rescheduled-event-notification/rescheduled-event-notification.component';
import {
  ResetPasswordTemplateComponent,
  ResetPasswordTemplateMocks,
} from './app/templates/reset-password/reset-password.component';
import {
  ShareContainerTemplateComponent,
  ShareContainerTemplateMocks,
} from './app/templates/share-container/share-container.component';
import {
  SignInDetectedTemplateComponent,
  SignInDetectedTemplateMocks,
} from './app/templates/sign-in-detected/sign-in-detected.component';
import {
  SignUpVerificationReminderTemplateComponent,
  SignUpVerificationReminderTemplateMocks,
} from './app/templates/sign-up-verification-reminder/sign-up-verification-reminder.component';
import {
  SingleNotificationTemplateComponent,
  SingleNotificationTemplateMocks,
} from './app/templates/single-notification/single-notification.component';
import {
  SlotsUpgradedTemplateComponent,
  SlotsUpgradedTemplateMocks,
} from './app/templates/slots-upgraded/slots-upgraded.component';
import {
  SsoEnabledTemplateComponent,
  SsoEnabledTemplateMocks,
} from './app/templates/sso-enabled/sso-enabled.component';
import {
  SystemChangedVideoProviderTemplateComponent,
  SystemChangedVideoProviderTemplateMocks,
} from './app/templates/system-changed-video-provider/system-changed-video-provider.component';
import {
  TellentAccountActivationTemplateComponent,
  TellentAccountActivationTemplateMocks,
} from './app/templates/tellent-account-activation/tellent-account-activation.component';
import {
  TellentAccountConfirmationTemplateComponent,
  TellentAccountConfirmationTemplateMocks,
} from './app/templates/tellent-account-confirmation/tellent-account-confirmation.component';
import {
  TellentAccountDeletedTemplateComponent,
  TellentAccountDeletedTemplateMocks,
} from './app/templates/tellent-account-deleted/tellent-account-deleted.component';
import {
  TellentAccountInvitationTemplateComponent,
  TellentAccountInvitationTemplateMocks,
} from './app/templates/tellent-account-invitation/tellent-account-invitation.component';
import {
  TellentAccountRecoveryTemplateComponent,
  TellentAccountRecoveryTemplateMocks,
} from './app/templates/tellent-account-recovery/tellent-account-recovery.component';
import {
  TellentAccountRecoveryRequestStartedTemplateComponent,
  TellentAccountRecoveryRequestStartedTemplateMocks,
} from './app/templates/tellent-account-recovery-request-started/tellent-account-recovery-request-started.component';
import {
  TellentAuthMigrationTemplateComponent,
  TellentAuthMigrationTemplateMocks,
} from './app/templates/tellent-auth-migration/tellent-auth-migration.component';
import {
  TellentEmailChangedTemplateComponent,
  TellentEmailChangedTemplateMocks,
} from './app/templates/tellent-email-changed/tellent-email-changed.component';
import {
  TellentEmailConfirmationTemplateComponent,
  TellentEmailConfirmationTemplateMocks,
} from './app/templates/tellent-email-confirmation/tellent-email-confirmation.component';
import {
  TellentEmailVerificationCodeTemplateComponent,
  TellentEmailVerificationCodeTemplateMocks,
} from './app/templates/tellent-email-verification-code/tellent-email-verification-code.component';
import {
  TellentOrgDeletedTemplateComponent,
  TellentOrgDeletedTemplateMocks,
} from './app/templates/tellent-org-deleted/tellent-org-deleted.component';
import {
  TellentOrgVerificationRequestTemplateComponent,
  TellentOrgVerificationRequestTemplateMocks,
} from './app/templates/tellent-org-verification-request/tellent-org-verification-request.component';
import {
  TellentRequestAccountDeletionTemplateComponent,
  TellentRequestAccountDeletionTemplateMocks,
} from './app/templates/tellent-request-account-deletion/tellent-request-account-deletion.component';
import {
  TellentRequestEmailChangeTemplateComponent,
  TellentRequestEmailChangeTemplateMocks,
} from './app/templates/tellent-request-email-change/tellent-request-email-change.component';
import {
  TellentRequestOrgDeletionTemplateComponent,
  TellentRequestOrgDeletionTemplateMocks,
} from './app/templates/tellent-request-org-deletion/tellent-request-org-deletion.component';
import {
  TellentResetPasswordTemplateComponent,
  TellentResetPasswordTemplateMocks,
} from './app/templates/tellent-reset-password/tellent-reset-password.component';
import {
  TellentSignInDetectedTemplateComponent,
  TellentSignInDetectedTemplateMocks,
} from './app/templates/tellent-sign-in-detected/tellent-sign-in-detected.component';
import {
  TellentSsoEnabledTemplateComponent,
  TellentSsoEnabledTemplateMocks,
} from './app/templates/tellent-sso-enabled/tellent-sso-enabled.component';
import {
  TellentVerifyEmailTemplateComponent,
  TellentVerifyEmailTemplateMocks,
} from './app/templates/tellent-verify-email/tellent-verify-email.component';
import {
  TextingCampaignRequestNotificationTemplateComponent,
  TextingCampaignRequestNotificationTemplateMocks,
} from './app/templates/texting-campaign-request-notification/texting-campaign-request-notification.component';
import {
  TextingNotificationTemplateComponent,
  TextingNotificationTemplateMocks,
} from './app/templates/texting-notification/texting-notification.component';
import {
  TextingNumberDeletedTemplateComponent,
  TextingNumberDeletedTemplateMocks,
} from './app/templates/texting-number-deleted/texting-number-deleted.component';
import {
  TextingNumberDeletionScheduledTemplateComponent,
  TextingNumberDeletionScheduledTemplateMocks,
} from './app/templates/texting-number-deletion-scheduled/texting-number-deletion-scheduled.component';
import {
  VerificationCodeTemplateComponent,
  VerificationCodeTemplateMocks,
} from './app/templates/verification-code/verification-code.component';
import {
  VerificationUrlTemplateComponent,
  VerificationUrlTemplateMocks,
} from './app/templates/verification-url/verification-url.component';
import {
  VerificationUrlAndCodeTemplateComponent,
  VerificationUrlAndCodeTemplateMocks,
} from './app/templates/verification-url-and-code/verification-url-and-code.component';
import {
  WebhookDeliveryFailedTemplateComponent,
  WebhookDeliveryFailedTemplateMocks,
} from './app/templates/webhook-delivery-failed/webhook-delivery-failed.component';
import {
  WebhookPlanDowngradedTemplateComponent,
  WebhookPlanDowngradedTemplateMocks,
} from './app/templates/webhook-plan-downgraded/webhook-plan-downgraded.component';

export const TEMPLATE_ROUTES: Array<Route & { name: string; render: boolean }> = [
  ...provideTemplateDefinition('demo', DemoTemplateComponent, DemoTemplateMocks),
  ...provideTemplateDefinition(
    'account_recovery_request_started',
    AccountRecoveryRequestStartedTemplateComponent,
    AccountRecoveryRequestStartedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'account_recovery_request_url',
    AccountRecoveryRequestUrlTemplateComponent,
    AccountRecoveryRequestUrlTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'admin_deleted',
    AdminDeletedTemplateComponent,
    AdminDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'admin_deletion_request_created',
    AdminDeletionRequestCreatedTemplateComponent,
    AdminDeletionRequestCreatedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'admin_deletion_scheduled',
    AdminDeletionScheduledTemplateComponent,
    AdminDeletionScheduledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'broken_sync_alert',
    BrokenSyncAlertTemplateComponent,
    BrokenSyncAlertTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company_deleted',
    CompanyDeletedTemplateComponent,
    CompanyDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company_deletion_request_created',
    CompanyDeletionRequestCreatedTemplateComponent,
    CompanyDeletionRequestCreatedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company_deletion_scheduled',
    AdminDeletionScheduledTemplateComponent,
    CompanyDeletionScheduledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'complete_account_setup',
    CompleteAccountSetupTemplateComponent,
    CompleteAccountSetupTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'eeo_data_request',
    EeoDataRequestTemplateComponent,
    EeoDataRequestTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'email_change_start_process',
    EmailChangeStartProcessTemplateComponent,
    EmailChangeStartProcessTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'email_change_verification',
    EmailChangeVerificationTemplateComponent,
    EmailChangeVerificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'event_notification',
    EventNotificationTemplateComponent,
    EventNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'gdpr_auto_consent',
    GdprAutoConsentTemplateComponent,
    GdprAutoConsentTemplateMocks,
  ),
  ...provideTemplateDefinition('gdpr_report', GdprReportTemplateComponent, GdprReportTemplateMocks),
  ...provideTemplateDefinition(
    'inactive_admin_deleted',
    InactiveAdminDeletedTemplateComponent,
    InactiveAdminDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'inactive_company_deleted',
    InactiveAdminDeletedTemplateComponent,
    InactiveCompanyDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'join_company',
    JoinCompanyTemplateComponent,
    JoinCompanyTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'multiple_notifications',
    MultipleNotificationsTemplateComponent,
    MultipleNotificationsTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'new_candidate',
    NewCandidateTemplateComponent,
    NewCandidateTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'new_candidates_report',
    NewCandidatesReportTemplateComponent,
    NewCandidatesReportTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'notification_mention',
    NotificationMentionTemplateComponent,
    NotificationMentionTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'referral_application_confirmation',
    ReferralApplicationConfirmationTemplateComponent,
    ReferralApplicationConfirmationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'referral_email_confirmation',
    ReferralEmailConfirmationTemplateComponent,
    ReferralEmailConfirmationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'referral_send_invitation',
    ReferralSendInvitationTemplateComponent,
    ReferralSendInvitationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'requisitions_approval_request',
    RequisitionsApprovalRequestTemplateComponent,
    RequisitionsApprovalRequestTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'reset_password',
    ResetPasswordTemplateComponent,
    ResetPasswordTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'share_container',
    ShareContainerTemplateComponent,
    ShareContainerTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'sign_up_verification_reminder',
    SignUpVerificationReminderTemplateComponent,
    SignUpVerificationReminderTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'single_notification',
    SingleNotificationTemplateComponent,
    SingleNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'slots_upgraded',
    SlotsUpgradedTemplateComponent,
    SlotsUpgradedTemplateMocks,
  ),
  ...provideTemplateDefinition('sso_enabled', SsoEnabledTemplateComponent, SsoEnabledTemplateMocks),
  ...provideTemplateDefinition(
    'verification_code',
    VerificationCodeTemplateComponent,
    VerificationCodeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'verification_url',
    VerificationUrlTemplateComponent,
    VerificationUrlTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'verification_url_and_code',
    VerificationUrlAndCodeTemplateComponent,
    VerificationUrlAndCodeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'webhook_delivery_failed',
    WebhookDeliveryFailedTemplateComponent,
    WebhookDeliveryFailedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'webhook_plan_downgraded',
    WebhookPlanDowngradedTemplateComponent,
    WebhookPlanDowngradedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting_notification',
    TextingNotificationTemplateComponent,
    TextingNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting_number_deletion_scheduled',
    TextingNumberDeletionScheduledTemplateComponent,
    TextingNumberDeletionScheduledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'sign_in_detected',
    SignInDetectedTemplateComponent,
    SignInDetectedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting_campaign_request_notification',
    TextingCampaignRequestNotificationTemplateComponent,
    TextingCampaignRequestNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'feature_request_created',
    FeatureRequestCreatedTemplateComponent,
    FeatureRequestCreatedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'company_verification_request',
    CompanyVerificationRequestTemplateComponent,
    CompanyVerificationRequestTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'candidate_shared',
    CandidateSharedTemplateComponent,
    CandidateSharedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'before_subscription_downgrade',
    BeforeSubscriptionDowngradeTemplateComponent,
    BeforeSubscriptionDowngradeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'after_subscription_downgrade',
    AfterSubscriptionDowngradeTemplateComponent,
    AfterSubscriptionDowngradeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'system_changed_video_provider',
    SystemChangedVideoProviderTemplateComponent,
    SystemChangedVideoProviderTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'texting_number_deleted',
    TextingNumberDeletedTemplateComponent,
    TextingNumberDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'event_reminder_scheduled',
    EventReminderScheduledTemplateComponent,
    EventReminderScheduledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_account_confirmation',
    TellentAccountConfirmationTemplateComponent,
    TellentAccountConfirmationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_account_invitation',
    TellentAccountInvitationTemplateComponent,
    TellentAccountInvitationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_reset_password',
    TellentResetPasswordTemplateComponent,
    TellentResetPasswordTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_sign_in_detected',
    TellentSignInDetectedTemplateComponent,
    TellentSignInDetectedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_auth_migration',
    TellentAuthMigrationTemplateComponent,
    TellentAuthMigrationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_email_verification_code',
    TellentEmailVerificationCodeTemplateComponent,
    TellentEmailVerificationCodeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_account_recovery',
    TellentAccountRecoveryTemplateComponent,
    TellentAccountRecoveryTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_account_recovery_request_started',
    TellentAccountRecoveryRequestStartedTemplateComponent,
    TellentAccountRecoveryRequestStartedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_sso_enabled',
    TellentSsoEnabledTemplateComponent,
    TellentSsoEnabledTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_account_activation',
    TellentAccountActivationTemplateComponent,
    TellentAccountActivationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_email_confirmation',
    TellentEmailConfirmationTemplateComponent,
    TellentEmailConfirmationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_request_email_change',
    TellentRequestEmailChangeTemplateComponent,
    TellentRequestEmailChangeTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_verify_email',
    TellentVerifyEmailTemplateComponent,
    TellentVerifyEmailTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_email_changed',
    TellentEmailChangedTemplateComponent,
    TellentEmailChangedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'email_not_delivered',
    EmailNotDeliveredTemplateComponent,
    EmailNotDeliveredTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_request_account_deletion',
    TellentRequestAccountDeletionTemplateComponent,
    TellentRequestAccountDeletionTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_account_deleted',
    TellentAccountDeletedTemplateComponent,
    TellentAccountDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_request_org_deletion',
    TellentRequestOrgDeletionTemplateComponent,
    TellentRequestOrgDeletionTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_org_deleted',
    TellentOrgDeletedTemplateComponent,
    TellentOrgDeletedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'tellent_org_verification_request',
    TellentOrgVerificationRequestTemplateComponent,
    TellentOrgVerificationRequestTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'campaign_submitted',
    CampaignSubmittedTemplateComponent,
    CampaignSubmittedTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'campaign_contract_submitted_template',
    CampaignContractSubmittedTemplateTemplateComponent,
    CampaignContractSubmittedTemplateTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'rescheduled_event_notification',
    RescheduledEventNotificationTemplateComponent,
    RescheduledEventNotificationTemplateMocks,
  ),
  ...provideTemplateDefinition(
    'campaign_product_status_changed',
    CampaignProductStatusChangedTemplateComponent,
    CampaignProductStatusChangedTemplateMocks,
  ),
];
